import styled from 'styled-components'

export const HomeWrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100vh;
`

export const BrandsGridContainer = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`
